import {defaultMapper} from "@/common/service/default-mapper";
import { dependMeetingPlanTypeList, PlanModelInfo, planTypes } from '@/common/constants';
import { transferMoney } from "@/utils/money";

export const BASE_UNIT = 1024;

export const cmrCapacityMap = {
  'cmr30': { capacity: 30, approxHours: 100 },
  'cmr40_upgrade': { capacity: 200, approxHours: 650 },
  'cmr100_upgrade': { capacity: BASE_UNIT, approxHours: 3500 },
  'cmr500_upgrade': { capacity: BASE_UNIT * 5, approxHours: 17500 },
  'cmr40': { capacity: 100 },
  'cmr100': { capacity: 500 },
  'cmr500': { capacity: BASE_UNIT * 3 },
};

export const CMRVisibleCategories = ['cmr30', 'cmr40_upgrade', 'cmr100_upgrade', 'cmr500_upgrade']

export default planMapJSON => {
  const cmrList = Object.keys(cmrCapacityMap).reduce((pre, key) => {
    const categoryValue = planMapJSON[key] || {};
    const category = categoryValue?.category;
    const {capacity} = cmrCapacityMap[category];

    return [...pre, ...defaultMapper(categoryValue, planTypes.CMR).map((item) => {
      return {
        ...item,
        capacity,
        isVisible: CMRVisibleCategories.includes(category),
        price: categoryValue.price,
        excessPrice: transferMoney(categoryValue.excessPriceCents),
        excessPriceCents: categoryValue.excessPriceCents,
        cartCapacityUnit: capacity < BASE_UNIT ? 'GB' : 'TB',
        cartCapacity: capacity < BASE_UNIT ? capacity : Math.floor(capacity / BASE_UNIT),
        typeNameKey: 'billing.cmr.title',
        planNameKey: 'billing.cmr.title',
        dependBasePlanTypeList: dependMeetingPlanTypeList,
        planModel: PlanModelInfo.usage,
        approxHours: cmrCapacityMap[category]?.approxHours
      }
    })];
  }, []);

  return cmrList;
}
